(() => {
  class ProductMediaGallery {
    constructor(root) {
      this.root = root;
      this.main = root.querySelector('[data-product-media-main]');
      this.thumbs = [...root.querySelectorAll('[data-product-thumb]')];
      this.bind();
    }

    bind() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(thumb));
      });

      this.main?.addEventListener('click', () => {
        const img = this.main.querySelector('img');
        if (!img) return;
        if (img.style.transform === 'scale(1.6)') {
          img.style.transform = '';
          img.style.cursor = 'zoom-in';
        } else {
          img.style.transform = 'scale(1.6)';
          img.style.cursor = 'zoom-out';
          img.style.transformOrigin = 'center center';
          img.style.transition = 'transform 180ms ease';
        }
      });

      let startX = 0;
      this.main?.addEventListener(
        'touchstart',
        (event) => {
          startX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );
      this.main?.addEventListener(
        'touchend',
        (event) => {
          const endX = event.changedTouches[0].screenX;
          const delta = endX - startX;
          if (Math.abs(delta) < 40) return;
          const currentIndex = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
          const nextIndex =
            delta < 0
              ? Math.min(this.thumbs.length - 1, currentIndex + 1)
              : Math.max(0, currentIndex - 1);
          if (this.thumbs[nextIndex]) this.select(this.thumbs[nextIndex]);
        },
        { passive: true }
      );
    }

    select(thumb) {
      const mediaId = thumb.dataset.productThumb;
      const src = thumb.dataset.fullSrc;
      const alt = thumb.dataset.alt || '';
      const img = this.main?.querySelector('img');
      if (img && src) {
        img.src = src;
        img.alt = alt;
        img.style.transform = '';
        img.style.cursor = 'zoom-in';
      }
      this.thumbs.forEach((t) => {
        t.classList.toggle('is-active', t === thumb);
        t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
      });
      this.root.dispatchEvent(new CustomEvent('product:media-change', { detail: { mediaId } }));
    }
  }

  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.form = root.closest('form') || document.querySelector('[data-product-form]');
      const jsonEl = this.form?.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
      this.product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      this.optionInputs = [...root.querySelectorAll('[data-option-input]')];
      this.priceEls = document.querySelectorAll('[data-product-price]');
      this.skuInput = this.form?.querySelector('[name="id"]');
      this.submitButtons = document.querySelectorAll('[data-product-add]');
      this.bind();
      this.update();
    }

    bind() {
      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.syncSelectedClasses();
          this.update();
        });
      });
    }

    syncSelectedClasses() {
      this.optionInputs.forEach((input) => {
        const labelSpan = input.parentElement?.querySelector('.variant-option');
        if (labelSpan) labelSpan.classList.toggle('is-selected', input.checked);
      });
    }

    selectedOptions() {
      const options = [];
      const names = [...new Set(this.optionInputs.map((i) => i.getAttribute('name')))];
      names.forEach((name) => {
        const selected =
          this.optionInputs.find((i) => i.getAttribute('name') === name && i.checked) ||
          this.optionInputs.find((i) => i.getAttribute('name') === name);
        if (selected) options.push(selected.value);
      });
      return options;
    }

    findVariant() {
      if (!this.product) return null;
      const selected = this.selectedOptions();
      return this.product.variants.find((variant) =>
        variant.options.every((option, index) => option === selected[index])
      );
    }

    update() {
      const variant = this.findVariant();
      if (!variant) {
        this.submitButtons.forEach((btn) => {
          btn.disabled = true;
          btn.textContent = window.theme?.strings?.unavailable || 'Unavailable';
        });
        return;
      }

      if (this.skuInput) {
        this.skuInput.value = variant.id;
        this.skuInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.priceEls?.length) {
        const price = window.theme.formatMoney(variant.price, window.theme.moneyFormat);
        let html;
        if (variant.compare_at_price > variant.price) {
          const compare = window.theme.formatMoney(variant.compare_at_price, window.theme.moneyFormat);
          html = `<span class="price"><span class="price__sale">${price}</span><s class="price__compare">${compare}</s></span>`;
        } else {
          html = `<span class="price"><span class="price__regular">${price}</span></span>`;
        }
        this.priceEls.forEach((el) => {
          el.innerHTML = html;
        });
      }

      this.submitButtons.forEach((btn) => {
        if (!variant.available) {
          btn.disabled = true;
          btn.textContent = window.theme?.strings?.soldOut || 'Sold out';
        } else {
          btn.disabled = false;
          btn.textContent = window.theme?.strings?.addToCart || 'Add to cart';
        }
      });

      const featuredMediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (featuredMediaId) {
        const thumb = document.querySelector(`[data-product-thumb="${featuredMediaId}"]`);
        thumb?.click();
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  document.querySelectorAll('[data-product-gallery]').forEach((el) => new ProductMediaGallery(el));
  document.querySelectorAll('[data-variant-picker]').forEach((el) => new VariantPicker(el));
})();
